
import { connect } from 'react-redux'
import { push } from 'react-router-redux'
import { bindActionCreators } from 'redux'
import { compose, withState, withHandlers, lifecycle } from 'recompose'

import { pathOr } from 'ramda'

import { meetsAllRequirements, getDefaultConfig } from 'utils/password'
import { isEmailValid, emailHasInvalidDomain } from 'utils/email'

import { createOrg } from 'modules/org/actions'
import { getPassword, getEmail } from 'modules/user/selectors'
import { setPassword, checkUniqueEmail, setEmail } from 'modules/user/actions'

import { page } from 'utils/trackingUtils'

import Deal from './component'
import { getDeal } from 'modules/billing/selectors'
import { BillingCollectionMethod } from 'constants/dealConstants'


const ButtonLabels = Object.freeze({
  MANUAL: 'Create account',
  AUTOMATIC: 'Next'
})

const resolveButtonName = (state) => {
  const deal = getDeal(state)
  const collectionMethod = pathOr(BillingCollectionMethod.AUTOMATIC, ['customerInfo', 'billingCollectionMethod'], deal)
  return ButtonLabels[collectionMethod]
}


const mapStateToProps = state => ({
  email: getEmail(state),
  password: getPassword(state),
  buttonName: resolveButtonName(state)
})
const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({
    push,
    createOrg,
    setEmail,
    setPassword,
    checkUniqueEmail
  }, dispatch),
})

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withState('emailHasInvalidDomain', 'setEmailHasInvalidDomain', false),
  withState('isEmailUnique', 'setIsEmailUnique', true),
  withState('isEmailValid', 'setIsEmailValid', true),
  withState('isPasswordValid', 'setIsPasswordValid', false),
  withHandlers({
    onEmailUpdated: props => ({ target }) => {
      props.actions.setEmail(target.value)
      props.setIsEmailUnique(props.actions.checkUniqueEmail(target.value))
      props.setIsEmailValid(isEmailValid(target.value))
      props.setEmailHasInvalidDomain(emailHasInvalidDomain(target.value))
    },
    onPasswordUpdated: props => ({ target }) => {
      props.actions.setPassword(target.value)
      props.setIsPasswordValid(meetsAllRequirements(target.value, getDefaultConfig()))
    },
    onNextClicked: props => () => {
      props.onNextClicked()
    },
    onInitPasswordCheck: props => (value) => {
      props.setIsPasswordValid(meetsAllRequirements(value, getDefaultConfig()))
    }
  }),
  lifecycle({
    componentDidMount() {
      page('Paid Deal Flow - Create Account Step')
    }
  })
)(Deal)



// WEBPACK FOOTER //
// ./src/layouts/Deal/CreateAccountStep/index.js